<template>
  <div v-if="visible" class="modal-overlay">
    <div class="modal-dialog modal-dialog-centered modal-lg w-100" role="document">
      <div class="modal-content radius-8">
        <div class="d-flex align-items-center justify-content-between">
          <h5 class="modal-title" id="sizeGuideModalLabel">{{ guideTitle }}</h5>
          <button type="button" class="close" @click="closeModal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body p-0 my-3">
          <div class="text-center">
            <img :src="imageUrl" alt="Size Guide" v-if="imageUrl" />
            <p v-else class="m-0">{{ noImageMessage }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      visible: {
        type: Boolean,
        required: true
      },
      currentUser: {
        type: Object,
        required: true
      },
      customer: {
        type: Object,
        required: true
      },
      vendor: {
        type: Object,
        required: true
      },
      type: {
        type: String,
        required: true
      },
      enabledSportsSite: {
        type: String,
        required: true
      }
    },
    computed: {
      // TODO: See if the attribute at app/helpers/application_helper.rb:24 is needed here
      guideTitle() {
        if (this.type === 'jerseys') {
          return this.customer.translations.jersey_size_guide;
        } else if (this.type === 'shorts') {
          return this.customer.translations.shorts_size_guide;
        }
        return null;
      },
      imageUrl() {
        const vendor = this.vendor || {};
        const language = this.customer.language;
        const sport = this.enabledSportsSite;
        const hasSoccer = this.customer.soccer_sports;
        const hasHockey = this.customer.hockey_sports;

        // Jerseys
        if (this.type === 'jerseys') {
          if (sport === 'Soccer' && hasSoccer) {
            return language === 'FRENCH'
              ? vendor.french_soccer_jersey_size_guide_url || null
              : vendor.size_guide_image_url || null;
          } else if (sport === 'Hockey' && hasHockey) {
            return language === 'FRENCH'
              ? vendor.french_hockey_jersey_size_guide_url || null
              : vendor.hockey_size_guide_image_url || null;
          }
        }

        // Shorts
        if (this.type === 'shorts') {
          if (sport === 'Soccer' && hasSoccer) {
            return language === 'FRENCH'
              ? vendor.french_soccer_shorts_size_guide_url || null
              : vendor.soccer_shorts_image_url || null;
          } else if (sport === 'Hockey' && hasHockey) {
            return language === 'FRENCH'
              ? vendor.french_hockey_shorts_size_guide_url || null
              : vendor.hockey_shorts_image_url || null;
          }
        }

        // Socks
        if (this.type === 'socks') {
          if (sport === 'Soccer' && hasSoccer) {
            return language === 'FRENCH'
              ? vendor.french_soccer_socks_size_guide_url || null
              : vendor.soccer_socks_image_url || null;
          } else if (sport === 'Hockey' && hasHockey) {
            return language === 'FRENCH'
              ? vendor.french_hockey_socks_size_guide_url || null
              : vendor.hockey_socks_image_url || null;
          }
        }

        return null; // Fallback
      },
      noImageMessage() {
        return 'No Size Guide Available';
      }
    },
    methods: {
      closeModal() {
        this.$emit('close');
      }
    }
  };
</script>
